import { LoadingButton } from '@mui/lab'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@mui/material'

type RemoveInvitationDialogProps = DialogProps & {
  onClose: () => void
  onRemoveInvitation: () => void
  isLoading: boolean
}

export function RemoveInvitationDialog({
  onRemoveInvitation,
  isLoading,
  ...props
}: RemoveInvitationDialogProps) {
  return (
    <Dialog {...props}>
      <DialogTitle>Remover convite</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Tem certeza que deseja remover o convite para esse colaborador?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={props.onClose}>
          Cancelar
        </Button>
        <LoadingButton
          loading={isLoading}
          onClick={onRemoveInvitation}
          color="error"
        >
          Remover
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
